export default "__VITE_ASSET__be9cd54d__"